import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import { MessageSquarePlus } from 'lucide-react';
export const CreateCampaignButton = () => {
    const { t } = useTranslation();
    return (<Button size="sm" asChild>
            <Link to="/console/campaigns/new">
                <MessageSquarePlus />
                {t('create_campaign')}
            </Link>
        </Button>);
};
